// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__uFRxN","errorLogs":"styles_errorLogs___ev3d"};